define('controllers/address_book_export/Podio.Controllers.AddbookExport.Main',['require','underscore','jquery','translate','backbone','lib/backbone/Backbone.PodioController','views/address_book_export/Podio.Views.AddbookExport','lib/backbone/Backbone.PodioModel','collections/Podio.Collections.AccountProviders','collections/Podio.Collections.LinkedAccounts','lib/Podio.Routes','lib/Podio.UI.Modal','lib/Podio.UI.FlashMessage','lib/Podio.SingleSignOn','lib/Podio.Transport'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var t = require('translate');
  var Backbone = require('backbone');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var ViewAddbookExport = require('views/address_book_export/Podio.Views.AddbookExport');
  var ModelPodioBase = require('lib/backbone/Backbone.PodioModel');
  var CollectionAccountProviders = require('collections/Podio.Collections.AccountProviders');
  var CollectionLinkedAccounts = require('collections/Podio.Collections.LinkedAccounts');

  var routes = require('lib/Podio.Routes');
  var modal = require('lib/Podio.UI.Modal');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var singleSignOn = require('lib/Podio.SingleSignOn');
  var transport = require('lib/Podio.Transport');

  return PodioController.extend({

    bindEvents: function() {
      this.eventBus.bind('addbookExportMainView:closeButtonClicked', this.closeModal, this);
      this.eventBus.bind('addbookExportMainView:connectAccountTriggered', this.connectAccount, this);
      this.eventBus.bind('addbookExportMainView:addToAddressbookTriggered', this.addToAddressbook, this);
    },

    initialize: function() {
      _.bindAll(this, 'onOAuthComplete', 'open');

      this.privateName = this.options.privateName;
      this.publicName = this.options.publicName;
      this.ref = this.options.ref;
      this.settingsPath = this.options.settingsPath;

      this.eventBus = _.extend({}, Backbone.Events);
      this.providersCollection = new CollectionAccountProviders();
      this.accountsCollection = new CollectionLinkedAccounts();
      this.addToAddressbookModel = new ModelPodioBase();
      this.bindEvents();
    },

    getContactPath: function(name) {
      if (this.ref) {
        return routes.email_contact_ref_path(name, this.ref.type, this.ref.id);
      } else {
        return routes.email_contact_global_path(name);
      }
    },

    getVCardPath: function(name) {
      if (this.ref) {
        return routes.email_contact_ref_vcard_path(name, this.ref.type, this.ref.id, {format: 'html'});
      } else {
        return routes.email_contact_global_vcard_path(name, {format: 'html'});
      }
    },

    getAddressbookPath: function() {
      if (this.ref) {
        return routes.email_contact_ref_export_path(this.privateName, this.ref.type, this.ref.id);
      } else {
        return routes.email_contact_global_export_path(this.privateName);
      }
    },

    getModalTitle: function() {
      if (this.privateName === 'space') {
        return t('Add the address to your addressbook for migrating existing conversations #email-to-workspace');
      } else {
        return t('Choose a service to add email to your address book #addressbook-export');
      }
    },

    loadMails: function() {
      if (!this.loadMailPromise) {
        var self = this;

        var privateReq = transport.getJSON(this.getContactPath(this.privateName));
        privateReq.done(function(responseData) {
          self.privateMail = responseData.data.object.mail;
        });

        if (this.publicName) {
          var publicReq = transport.getJSON(this.getContactPath(this.publicName));
          publicReq.done(function(responseData) {
            self.publicMail = responseData.data.object.mail;
          });

          this.loadMailPromise = $.when(privateReq, publicReq);
        } else {
          this.loadMailPromise = privateReq;
        }
      }

      return this.loadMailPromise;
    },

    open: function() {
      modal.showLoading(this.getModalTitle(), { width: 575 });

      var self = this;
      this.loadMails().done(function() {
        self.launchModal();
      });
    },

    launchModal: function() {
      // launch modal
      modal.show('', {
        title: this.getModalTitle(),
        className: 'address-book-export-modal',
        width: 665,
        autoHeight: true
      });

      // initialize view and render basics
      this.mainView = new ViewAddbookExport({
        el: $('.address-book-export-modal .modal-content'),
        privateEmail: this.privateMail,
        publicEmail: this.publicMail,
        privateName: this.privateName,
        publicName: this.publicName,
        providersCol: this.providersCollection,
        accountsCol: this.accountsCollection,
        vCardPath: this.getVCardPath(this.privateName),
        emailSettingsPath: this.settingsPath,
        eventBus: this.eventBus
      });

      // fetch data
      this.accountsCollection.getConnectedByCapability('addressbook');
      this.providersCollection.getAvailableFor('addressbook');

      $('.address-book-export-modal-content').css('maxHeight', modal.availableHeight());

    },

    closeModal: function() {
      modal.hide();
      this.trigger('onClose');
    },

    connectAccount: function(providerName) {
      singleSignOn.signals.onOAuthComplete.add(this.onOAuthComplete);
      singleSignOn.connect(providerName);
    },

    addToAddressbook: function(accountId) {
      var self = this;

      var req = this.addToAddressbookModel.request('post', this.getAddressbookPath(), {
        linked_acc_id: accountId
      });

      req.success(function(response) {
        if (response.status !== 'error') {
          self.mainView.setDoneStateOnAccountButton(accountId);
          flashMessage.show(t('The email address has been exported #calendar-export'));
        } else {
          self.mainView.setFailedStateOnAccountButton(accountId);
        }
      });
    },

    onOAuthComplete: function(data) {
      this.mainView.renderAccountsSpinner();
      // refresh accounts collection
      this.accountsCollection.getConnectedByCapability('addressbook');

      flashMessage.show(t('The account {0} has been successfully connected #calendar-export').format(data.label));

      // add to addressbook
      this.addToAddressbook(data.linked_account_id);
    }
  });

});

